<template>
  <div class="banner" v-if="!seen" :class="{ active: isActive, 'isDone': isDone  }">
    <div class="banner-header">
      <div class="banner-header__text pointer">
        <span @click="isActive = !isActive"><span class="icon-play3"></span> VIDEO: Føj til startskærm</span>
      </div>
      <div class="close" @click="setSeen">
        <span class="black-close box-shadow icon-cross2"></span>
      </div>
    </div>
    <div class="banner-body">
      <youtube
        :video-id="videoid"
        :player-width="w"
        :player-height="h">
      </youtube>
    </div>
  </div>
</template>

<script>
  import eventBus from '../../eventbus'
  export default {
    data () {
      return {
        videoid: 'GUsvPp2uuGk',
        seen: false,
        isActive: false,
        isDone: false,
        w: 320,
        h: 200
      }
    },
    methods: {
      setSeen () {
        this.isActive = false
        this.isDone = true
        setTimeout(() => {
          this.seen = true
        }, 300)

        // Global event to make Calendar resize
        eventBus.sideWideAnnouncement = false
        try {
          if (typeof (Storage) !== 'undefined') {
            window.localStorage.setItem('publicNewsSeen', true)
          }
        } catch (e) {
          // localstorage probably not enabled
        }
      },
      getMobileOperatingSystem () {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
          this.videoid = 'GUsvPp2uuGk'
        }
        if (/android/i.test(userAgent)) {
          this.videoid = 'Idpmc8dcFV0'
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          this.videoid = 'Vkw-bVsvkq4'
        }
      }
    },
    beforeMount () {
      try {
        if (typeof (Storage) !== 'undefined') {
          if (window.localStorage.getItem('publicNewsSeen') !== null) {
            this.seen = window.localStorage.getItem('publicNewsSeen')
          } else {
            this.w = window.innerWidth
            eventBus.sideWideAnnouncement = true
          }
        }
      } catch (e) {
        // localstorage probably not enabled
      }
      this.getMobileOperatingSystem()
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .banner {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10000;
    background: var(--blue);
    display: flex;
    color: #ffffff;
    flex-direction: column;
    font-size: 14px;
    text-align: center;
    transform: translateY(calc(100% - 50px));
    transition: all 0.3s;
    height: 100%
  }

  .banner.active {
    transform: translateY(0);
  }

  .banner.isDone {
    transform: translateY(calc(100%));
  }

  .banner-header {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;
  }

  .banner-header {
    padding-left: 20px;
  }

  .banner .close {
    cursor: pointer;
    height: 100%;
    padding: 0 20px;
    font-size: 18px;
    line-height: 50px;
  }

  .black-close {
    background: var(--dark-blue);
    border-radius: 50%;
    padding: 5px;
  }

</style>



// WEBPACK FOOTER //
// SiteWideAnnouncement.vue?33cbf0ad